import React from 'react';
import CitasDia from './citas_dia';
import { getUniqueKey, workWithLocalStorage } from '../../auxiliares/funciones';
import { getRooms, getServicios, getTiposPago } from '../../auxiliares/maestros';

export default function Citas(props) {
  const usuario = workWithLocalStorage('get', 'usuario', null);
  const [cargado, setCargado] = React.useState(false);
  const [servicios, setServicios] = React.useState([]);
  const [tiposPago, setTiposPago] = React.useState([]);
  const [rooms, setRooms] = React.useState([]);
  const [key, setKey] = React.useState(getUniqueKey);

  React.useEffect(() => {
    async function cargaInicial() {
      if (!cargado) {
        setServicios(await getServicios(usuario ? usuario.token : ''));
        setRooms(await getRooms(usuario ? usuario.token : ''));
        setTiposPago(await getTiposPago(usuario ? usuario.token : ''));
        if (props.showLoader) props.showLoader(false);
        setKey(getUniqueKey());
        setCargado(true);
      }
    }
    cargaInicial();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cargado]);

  if (cargado) {
    return (
      <CitasDia
        key={key}
        showLoader={props.showLoader}
        tiposPago={tiposPago}
        rooms={rooms}
        servicios={servicios}
      />
    );
  }
  return <></>;
}